<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <b-form class="mt-4" v-on:submit.prevent="guardarCuenta">
            <b-row class="text-left">
                <b-col>
                    <label>Nombre de la cuenta: *</label>
                    <b-form-input
                            v-model="nombre"
                            maxlength="50"
                            placeholder="Nombre cuenta"
                            :state="nombre != ''"
                            required
                    ></b-form-input>
                    <b-form-invalid-feedback :state="nombre != ''">
                        El nombre es requerido
                    </b-form-invalid-feedback>
                </b-col>
                <b-col>
                    <label>Número de la cuenta: *</label>
                    <b-form-input
                            v-model.trim="numero"
                            maxlength="14"
                            placeholder="Número de cuenta"
                            :state="numero != ''"
                            required
                    ></b-form-input>
                    <b-form-invalid-feedback :state="numero != ''">
                        El número es requerido
                    </b-form-invalid-feedback>
                </b-col>
            </b-row>

            <b-button
                    type="submit"
                    class="mt-4"
                    variant="outline-primary"
                    v-if="!enviando"
            >
                Guardar
            </b-button>

            <b-button class="mt-4" variant="primary" v-else disabled>
                <b-spinner small></b-spinner>
                Cargando...
            </b-button>
        </b-form>
    </div>
</template>

<script>
    import VueNotifications from "vue-notifications";

    export default {
        name: "AltaCuenta",
        data: () => ({
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,

            nombre: "",
            numero: "",
            enviando: false,
        }),
        methods: {
            guardarCuenta() {
                this.enviando = true;
                const urlCuenta = this.$api + "cuenta/bancaria";
                this.$http
                    .post(urlCuenta, this.traerDatos())
                    .then((response) => {
                        if (response.status === 200) {
                            this.$swal({
                                icon: "success",
                                text: "Se envio la información correctamente",
                                confirmButtonText: "OK",
                                confirmButtonColor: "#0e6ba9",
                            });
                            this.enviando = false;
                            this.nombre= "";
                            this.numero= "";
                        }
                    })
                    .catch((err) => {
                        this.enviando = false;
                        this.errorEnvio(err);
                    });
            },
            traerDatos() {
                return {
                    nombreCuenta: this.$global.limpiarTextoMayus(this.nombre),
                    numeroCuenta: this.numero,
                    usuarioLogeado: this.$localStorageService.getIdUsuario(),
                };
            },
        },
        notifications: {
            errorEnvio: {
                type: VueNotifications.types.error,
                title: "Error",
                message: "Error al enviar la información",
            },
        },
      created() {
        this.debug = this.$localStorageService.getDebug();
      }
    };
</script>
